import React, { useState } from 'react';
import { Typography } from '@material-ui/core';
import { CardCctv } from '../../components';
import { Skeleton } from '@material-ui/lab';

const LiveCctv = ({ isId }: any) => {
  const [loadingState, setLoadingState] = useState(true);
  const [cctvState, setCctvState] = useState<any>(null);

  const getData = async () => {
    try {
      const res: any = await fetch(`${process.env.REACT_APP_URL}/api/jlp/cctv`);
      const resJson = await res.json();
      const sortRows = resJson.data.rows.sort((a: any, b: any) =>
        a.name > b.name ? 1 : b.name > a.name ? -1 : 0
      );

      setCctvState(sortRows);
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  React.useEffect(() => {
    getData();
  }, []);

  return (
    <div
      style={{
        maxWidth: 1280,
        margin: '0 auto',
        padding: '0 16px',
      }}
    >
      <Typography style={{ marginBottom: '4rem' }}>
        {isId ? 'Jalan Tol Kami' : 'Our Toll Road'}
        &nbsp; &gt; &nbsp;{' '}
        <span style={{ color: '#e3232a' }}>
          {isId ? 'Live CCTV' : 'Live CCTV'}
        </span>
      </Typography>
      <Typography color='primary' variant='h4' style={{ marginBottom: '2rem' }}>
        {isId ? 'Live CCTV' : 'Live CCTV'}
      </Typography>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gridGap: '2rem',
          marginBottom: '4rem',
        }}
      >
        {loadingState ? (
          [1, 2, 3].map(() => (
            <div>
              <Skeleton
                variant='rect'
                height={30}
                style={{ marginBottom: 12 }}
              />
              <Skeleton variant='rect' height={200} />
            </div>
          ))
        ) : cctvState.length === 0 ? (
          <div
            style={{
              display: 'flex',
              width: '100%',
              paddingTop: 24,
            }}
          >
            <Typography color='textSecondary'>
              {isId ? 'Tidak ada Live CCTV' : 'No Live CCTV'}
            </Typography>
          </div>
        ) : (
          cctvState.map((row: any, index: number) => (
            <CardCctv
              key={row.id}
              idGroup={row.group_id}
              id={row.id}
              name={row.name}
              index={index}
              desc={row.description}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default LiveCctv;
